import { createSlice } from '@reduxjs/toolkit';

import { PlaylistTag } from '~/@types/tsl-types';
import { playlistApi } from '~/services/api/playlist.service';

interface PlaylistState {
  playlists: PlaylistTag[];
  selectedPlaylistId: string | null;
}

const initialState = {
  playlists: [],
  selectedPlaylistId: null,
} as PlaylistState;

export const playlistSlice = createSlice({
  name: 'playlist',
  initialState,
  reducers: {
    setSelectedPlaylistId: (state, action) => {
      state.selectedPlaylistId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(playlistApi.endpoints.getPlaylists.matchFulfilled, (state, { payload }) => {
      state.playlists = payload;
    });
  },
});
